import React from 'react'
import { Discord, GithubIcon, SvgProps, TelegramNew, TwitterNew } from 'vvs-uikit'

export enum Social {
  TWITTER = 'twitter',
  TELEGRAM = 'tg',
  GITHUB = 'github',
  DISCORD = 'discord',
}
export const socials: Record<
  Social,
  {
    href: string
    label: string
    Icon: React.FC<SvgProps>
  }
> = {
  [Social.TWITTER]: {
    href: 'https://twitter.com/VVS_finance',
    label: 'Twitter',
    Icon: TwitterNew,
  },
  [Social.DISCORD]: {
    href: 'https://discord.gg/V2957zMsmg',
    label: 'Discord',
    Icon: Discord,
  },
  [Social.TELEGRAM]: {
    href: 'https://t.me/VVSFinance',
    label: 'Telegram',
    Icon: TelegramNew,
  },
  [Social.GITHUB]: {
    href: 'https://github.com/vvs-finance/',
    label: 'Github',
    Icon: GithubIcon,
  },
}
